// extracted by mini-css-extract-plugin
module.exports = {"m18jy2hl":"m18jy2hl"};